<template>
    <div id="singleEvent">
        <h1>{{event_data.name}}</h1>
        <p v-if="!event_data.invalid">{{event_data.desc}}</p>
        <p v-if="event_data.invalid">This event doesn't exist! <router-link to="/">Return home</router-link></p>
        <div id="eventTotals" v-if="!event_data.invalid">
            <div id="eventCo2" class="calculated-icon">
                <i class="fas fa-cloud"></i>
                <div class="co2-overlay">CO2</div>
                <div class="icon-caption"><span class="calc-value">{{roundToDecimal(lbsCo2(event_data.mt), 1)}}</span>LBS of carbon<br/> offsets purchased</div>
            </div>
            <div id="eventTrees" class="calculated-icon">
                <i class="fas fa-tree"></i>
                <div class="icon-caption"><span class="calc-value">{{roundToDecimal(event_data.trees, 1)}}</span> Trees</div>
            </div>
        </div>
        <router-link to="/" class="button-submit" v-if="!event_data.invalid">Contribute Now</router-link>
        <sponsor-info v-if="event_data.sponsor" :name="event_data.sponsor.name" :message="event_data.sponsor.message" :logo="event_data.sponsor.logo"></sponsor-info>
        <div id="contributions" v-if="!event_data.invalid">
            <h3 id="contribHead">Contributors</h3>
            <table id="contributorList">
                <tr class="contributor" v-for="contributor in event_data.contributors">
                    <td class="contrib-amount">${{contributor.amount.toFixed(2)}}</td>
                    <td class="contrib-name">{{contributor.name}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import SponsorInfo from "./SponsorInfo";
    import formatting from "../mixins/formatting";

    export default {
        name: "Event",
        components: {SponsorInfo},
        mixins: [formatting],
        data() {
            return {
                id: this.$route.params.id,
                event_data: {}
            };
        },
        methods: {
            async setup() {
                this.event_data = await axios.get(
                    this.$store.getters["server"] + "/event-details",
                    {
                        params: {
                            id: this.$route.params.id
                        }
                    }
                ).then((response) => {
                    response.data.object.contributors.sort((a, b) => {
                        return b.when - a.when;
                    });
                    return response.data.object;
                }, (response) => {
                    console.log(response);
                    return {
                        name: "404: Event does not exist",
                        invalid: true
                    };
                });
            },
            lbsCo2(mt) {
                return mt * 2204.623;
            }

        },
        watch: {
            "$route.params.id": () => {
                this.setup();
            }
        },
        mounted() {
            this.setup();
        }
    };
</script>

<style scoped lang="less">
    @import (reference) "../assets/variables";
    #eventTotals{
        display: flex;
        justify-content: space-around;
        margin-bottom: 1.5rem;
    }
    .icon-caption {
        font-size: 1rem;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: @light-gray;
    }

    .co2-overlay {
        font-size: 1.4rem;
        color: white;
        position: absolute;
        width: 100%;
        top: 1.25em;
        text-align: center;
        font-weight: 700;
    }
    .calculated-icon {
        text-align: center;
        font-size: 4rem;
        position: relative;
        color: @orange;
    }
    #contributions{
        clear: both;
    }
    #contribHead{
        margin: 1.5rem 0 0.5rem;
    }
    #contributorList{
        margin: 0 auto;
        padding: 0;
        text-align: left;
        width: 75%;
        min-width: 300px;
        border-collapse: collapse;
    }
    .contributor{
        border-bottom: 2px solid @lightest-gray;
        &:last-child{
            border: 0;
        }
    }
    .contrib-amount{
        font-size: 2rem;
        text-align: right;
        padding: 0.75rem 1rem  0.75rem 0;
    }
    .contrib-name{
        font-size: 1.3rem;
        padding: 0.75rem 0;
    }

</style>



// WEBPACK FOOTER //
// src/components/Event.vue